import SectionPanel from "pages/analytics/components/SectionPanel";
import {
  EmptyMessage,
  ErrorBanner,
  TableSkeleton,
} from "pages/analytics/components/AnalyticsStates";
import {
  formatCurrency,
  formatDate,
  formatNumber,
  formatPercent,
} from "pages/analytics/components/analyticsFormatters";

export default function GhlEmailPerformanceWidget({ data, isLoading, error }) {
  const email = data?.latest ?? data?.emailMetrics;
  const rangeLabel =
    data?.fromDate || data?.toDate
      ? `${formatDate(data.fromDate)} – ${formatDate(data.toDate)}`
      : null;

  return (
    <SectionPanel title="Email Performance">
      {error && (
        <div className="mb-4">
          <ErrorBanner message={error} />
        </div>
      )}

      {rangeLabel && !isLoading && email && (
        <p className="mb-3 text-xs text-gray-500">{rangeLabel}</p>
      )}

      {isLoading ? (
        <TableSkeleton rows={2} cols={3} />
      ) : !email ? (
        <EmptyMessage message="No email metrics synced yet." />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          <Metric label="Delivered" value={formatNumber(email.totalDelivered)} />
          <Metric label="Open Rate" value={formatPercent(email.openRate)} />
          <Metric label="CTR" value={formatPercent(email.clickThroughRate)} />
          <Metric label="List Size" value={formatNumber(email.listSize)} />
          <Metric label="Revenue" value={formatCurrency(email.revenue)} />
          <Metric label="Total Orders" value={formatNumber(email.totalOrders)} />
        </div>
      )}
    </SectionPanel>
  );
}

function Metric({ label, value }) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">{label}</p>
      <p className="mt-1 text-xl font-semibold text-gray-900">{value}</p>
    </div>
  );
}
